import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox } from "vue";
const _hoisted_1 = { class: "walkthroughs-page" };
const _hoisted_2 = { class: "alert-message" };
const _hoisted_3 = { class: "walkthroughs-container" };
const _hoisted_4 = { class: "walkthrough-info" };
const _hoisted_5 = { class: "walkthrough-title" };
const _hoisted_6 = { class: "walkthrough-key" };
const _hoisted_7 = { class: "section-header" };
const _hoisted_8 = { class: "header-actions-group" };
const _hoisted_9 = {
    key: 0,
    class: "json-editor-section"
};
const _hoisted_10 = {
    key: 0,
    class: "json-error"
};
const _hoisted_11 = {
    key: 1,
    class: "details-grid"
};
const _hoisted_12 = { class: "form-section" };
const _hoisted_13 = { class: "form-group" };
const _hoisted_14 = { class: "form-group" };
const _hoisted_15 = { class: "form-group" };
const _hoisted_16 = { class: "form-group" };
const _hoisted_17 = { class: "form-section" };
const _hoisted_18 = {
    key: 0,
    class: "slides-list"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = { class: "slide-number" };
const _hoisted_21 = { class: "header-actions" };
const _hoisted_22 = ["onClick", "disabled"];
const _hoisted_23 = ["onClick", "disabled"];
const _hoisted_24 = ["onClick"];
const _hoisted_25 = ["onClick"];
const _hoisted_26 = ["onClick"];
const _hoisted_27 = {
    key: 0,
    class: "slide-details"
};
const _hoisted_28 = { class: "slide-detail-row" };
const _hoisted_29 = { class: "detail-value" };
const _hoisted_30 = { class: "slide-detail-row" };
const _hoisted_31 = { class: "detail-value" };
const _hoisted_32 = { class: "slide-detail-row" };
const _hoisted_33 = { class: "detail-value" };
const _hoisted_34 = { class: "slide-detail-row" };
const _hoisted_35 = { class: "detail-value" };
const _hoisted_36 = { class: "slide-detail-row" };
const _hoisted_37 = { class: "detail-value" };
const _hoisted_38 = {
    key: 1,
    class: "empty-state-small"
};
const _hoisted_39 = {
    key: 1,
    class: "empty-state-section"
};
const _hoisted_40 = { class: "modal-header" };
const _hoisted_41 = { class: "modal-body" };
const _hoisted_42 = { class: "modal-footer" };
const _hoisted_43 = { class: "modal-header" };
const _hoisted_44 = { class: "modal-body" };
const _hoisted_45 = { class: "form-group" };
const _hoisted_46 = { class: "form-group" };
const _hoisted_47 = { class: "form-group" };
const _hoisted_48 = { class: "form-group" };
const _hoisted_49 = { class: "form-group" };
const _hoisted_50 = { class: "form-group" };
const _hoisted_51 = { class: "form-group" };
const _hoisted_52 = { class: "form-group" };
const _hoisted_53 = { class: "form-group" };
const _hoisted_54 = { class: "form-group" };
const _hoisted_55 = { class: "form-group" };
const _hoisted_56 = { class: "input-with-button" };
const _hoisted_57 = {
    key: 0,
    class: "image-preview-container"
};
const _hoisted_58 = ["src"];
const _hoisted_59 = ["src"];
const _hoisted_60 = { class: "form-group" };
const _hoisted_61 = { class: "modal-header" };
const _hoisted_62 = { class: "modal-body" };
const _hoisted_63 = { class: "search-box" };
const _hoisted_64 = {
    key: 0,
    class: "file-grid"
};
const _hoisted_65 = ["onClick"];
const _hoisted_66 = { class: "file-preview" };
const _hoisted_67 = ["src", "alt"];
const _hoisted_68 = { class: "file-card-info" };
const _hoisted_69 = ["title"];
const _hoisted_70 = {
    key: 1,
    class: "empty-state-small"
};
import { ref, computed, nextTick, onMounted } from 'vue';
import { useAdmin } from '@/composables/useAdmin';
import AdminHeaderActions from '@/admin/components/AdminHeaderActions.vue';
import AdminListSection from '@/admin/components/AdminListSection.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'WalkthroughAdminPage',
    setup(__props) {
        const admin = useAdmin();
        const loading = ref(false);
        const selectedWalkthrough = ref(null);
        const showAlert = ref(false);
        const alertMessage = ref('');
        const alertVariant = ref('success');
        const deleteConfirm = ref(false);
        const expandedSlides = ref([]);
        const showSlideModal = ref(false);
        const editingSlide = ref(null);
        const editingSlideIndex = ref(null);
        const showImageSearchModal = ref(false);
        const cdnFiles = ref([]);
        const imageSearchQuery = ref('');
        const walkthroughs = ref([]);
        const showJsonEditor = ref(false);
        const jsonEditorContent = ref('');
        const jsonError = ref('');
        const walkthroughDetailsSection = ref(null);
        const filteredCdnFiles = computed(() => {
            if (!cdnFiles.value)
                return [];
            const query = imageSearchQuery.value.toLowerCase();
            return cdnFiles.value.filter((f) => f.fileName.toLowerCase().includes(query) && ['jpg', 'jpeg', 'png', 'gif', 'svg'].some(ext => f.fileName.toLowerCase().endsWith(ext)));
        });
        function loadWalkthroughs() {
            loading.value = true;
            admin.getWalkthroughs((data) => {
                loading.value = false;
                walkthroughs.value = data || [];
                if (data && data.length > 0 && !selectedWalkthrough.value)
                    selectWalkthrough(data[0]);
            });
        }
        function selectWalkthrough(walkthrough) {
            selectedWalkthrough.value = JSON.parse(JSON.stringify(walkthrough));
            if (!selectedWalkthrough.value.slides)
                selectedWalkthrough.value.slides = [];
            expandedSlides.value = [];
            showJsonEditor.value = false;
            jsonEditorContent.value = '';
            jsonError.value = '';
            if (window.innerWidth <= 768)
                nextTick(() => walkthroughDetailsSection.value?.scrollIntoView({ behavior: 'smooth' }));
        }
        function duplicateWalkthrough(walkthrough) {
            const duplicate = JSON.parse(JSON.stringify(walkthrough));
            delete duplicate.id;
            duplicate.name = (duplicate.name || '') + ' (Copy)';
            duplicate.key = (duplicate.key || '') + '_copy';
            if (duplicate.slides) {
                duplicate.slides.forEach((slide) => delete slide.id);
            }
            loading.value = true;
            admin.createWalkthrough(duplicate, (res) => {
                showAlertMessage('Walkthrough duplicated successfully', 'success');
                loading.value = false;
                admin.getWalkthroughs((data) => {
                    walkthroughs.value = data || [];
                    const newWalkthrough = walkthroughs.value.find((w) => w.id === res.id);
                    if (newWalkthrough)
                        selectWalkthrough(newWalkthrough);
                });
            }, () => onSaveError('Failed to duplicate walkthrough'));
        }
        function newWalkthrough() {
            selectedWalkthrough.value = { title: '', key: '', autoScrollSeconds: 0, slides: [] };
            expandedSlides.value = [];
            showJsonEditor.value = false;
            jsonEditorContent.value = '';
            jsonError.value = '';
        }
        function saveWalkthrough() {
            let walkthroughToSave = selectedWalkthrough.value;
            // Apply JSON changes first if in JSON editor mode
            if (showJsonEditor.value) {
                try {
                    walkthroughToSave = JSON.parse(jsonEditorContent.value);
                    jsonError.value = '';
                }
                catch (e) {
                    jsonError.value = 'Invalid JSON: ' + e.message;
                    return;
                }
            }
            if (!walkthroughToSave.name) {
                showAlertMessage('Name is required', 'error');
                return;
            }
            if (!walkthroughToSave.key) {
                showAlertMessage('Key is required', 'error');
                return;
            }
            loading.value = true;
            if (walkthroughToSave.id) {
                admin.updateWalkthrough(walkthroughToSave.id, walkthroughToSave, () => {
                    selectedWalkthrough.value = walkthroughToSave;
                    onSaveSuccess();
                }, () => onSaveError('Failed to save walkthrough'));
            }
            else {
                admin.createWalkthrough(walkthroughToSave, (res) => onSaveSuccess(res), () => onSaveError('Failed to create walkthrough'));
            }
        }
        function toggleJsonEditor() {
            jsonError.value = '';
            if (showJsonEditor.value) {
                // Switching to form view - apply JSON changes
                try {
                    const parsed = JSON.parse(jsonEditorContent.value);
                    selectedWalkthrough.value = parsed;
                    showJsonEditor.value = false;
                }
                catch (e) {
                    jsonError.value = 'Invalid JSON: ' + e.message;
                }
            }
            else {
                // Switching to JSON view
                jsonEditorContent.value = JSON.stringify(selectedWalkthrough.value, null, 2);
                showJsonEditor.value = true;
            }
        }
        function onSaveSuccess(response) {
            showAlertMessage('Walkthrough saved successfully', 'success');
            loading.value = false;
            const newId = response ? response.id : selectedWalkthrough.value.id;
            // Reload walkthroughs and re-select the saved one
            admin.getWalkthroughs((data) => {
                walkthroughs.value = data || [];
                nextTick(() => {
                    const saved = walkthroughs.value.find((w) => w.id === newId);
                    if (saved)
                        selectWalkthrough(saved);
                });
            });
        }
        function onSaveError(message) {
            showAlertMessage(message, 'error');
            loading.value = false;
        }
        function showDeleteConfirm() {
            if (selectedWalkthrough.value?.id)
                deleteConfirm.value = true;
        }
        function deleteWalkthrough() {
            deleteConfirm.value = false;
            loading.value = true;
            admin.deleteWalkthrough(selectedWalkthrough.value.id, () => {
                showAlertMessage('Walkthrough deleted', 'success');
                selectedWalkthrough.value = null;
                loading.value = false;
                refreshWalkthroughs();
            }, () => onSaveError('Failed to delete walkthrough'));
        }
        function refreshWalkthroughs() {
            loadWalkthroughs();
        }
        function showAlertMessage(message, variant = 'success') {
            alertMessage.value = message;
            alertVariant.value = variant;
            showAlert.value = true;
            setTimeout(() => { showAlert.value = false; }, 4000);
        }
        function toggleSlide(index) {
            const idx = expandedSlides.value.indexOf(index);
            if (idx > -1)
                expandedSlides.value.splice(idx, 1);
            else
                expandedSlides.value.push(index);
        }
        function addSlide() {
            const nextOrder = selectedWalkthrough.value.slides ? selectedWalkthrough.value.slides.length : 0;
            editingSlide.value = {
                order: nextOrder,
                title: '',
                description: '',
                subDescription: '',
                screenTitle: '',
                actionText: '',
                actionUri: '',
                actionButtonColour: '',
                smallText: '',
                smallLink: '',
                imageUri: '',
                key: '',
                videoLoop: false
            };
            editingSlideIndex.value = null;
            showSlideModal.value = true;
        }
        function editSlide(slide, index) {
            editingSlide.value = { ...slide };
            editingSlideIndex.value = index;
            showSlideModal.value = true;
        }
        function saveSlide() {
            if (!editingSlide.value.title) {
                showAlertMessage('Slide title is required', 'error');
                return;
            }
            // Sanitise text fields to remove Unicode line/paragraph separators
            const textFields = ['title', 'description', 'subDescription', 'screenTitle', 'actionText', 'smallText'];
            textFields.forEach(field => {
                if (editingSlide.value[field]) {
                    editingSlide.value[field] = editingSlide.value[field].replace(/[\u2028\u2029]/g, ' ');
                }
            });
            if (editingSlideIndex.value !== null) {
                selectedWalkthrough.value.slides.splice(editingSlideIndex.value, 1, editingSlide.value);
            }
            else {
                selectedWalkthrough.value.slides.push(editingSlide.value);
            }
            updateSlideOrders();
            closeSlideModal();
        }
        function deleteSlide(index) {
            selectedWalkthrough.value.slides.splice(index, 1);
            updateSlideOrders();
        }
        function duplicateSlide(index) {
            const slide = selectedWalkthrough.value.slides[index];
            const duplicatedSlide = JSON.parse(JSON.stringify(slide));
            delete duplicatedSlide.id;
            selectedWalkthrough.value.slides.splice(index + 1, 0, duplicatedSlide);
            updateSlideOrders();
        }
        function moveSlideUp(index) {
            if (index > 0) {
                const temp = selectedWalkthrough.value.slides[index];
                selectedWalkthrough.value.slides[index] = selectedWalkthrough.value.slides[index - 1];
                selectedWalkthrough.value.slides[index - 1] = temp;
                updateSlideOrders();
                expandedSlides.value = [];
            }
        }
        function moveSlideDown(index) {
            if (index < selectedWalkthrough.value.slides.length - 1) {
                const temp = selectedWalkthrough.value.slides[index];
                selectedWalkthrough.value.slides[index] = selectedWalkthrough.value.slides[index + 1];
                selectedWalkthrough.value.slides[index + 1] = temp;
                updateSlideOrders();
                expandedSlides.value = [];
            }
        }
        function updateSlideOrders() {
            if (selectedWalkthrough.value.slides) {
                selectedWalkthrough.value.slides.forEach((slide, index) => {
                    slide.order = index;
                });
            }
        }
        function closeSlideModal() {
            showSlideModal.value = false;
            editingSlide.value = null;
            editingSlideIndex.value = null;
        }
        function openImageSearch() {
            showImageSearchModal.value = true;
            loadCdnFiles();
        }
        function loadCdnFiles() {
            admin.getFiles((files) => {
                cdnFiles.value = files || [];
            });
        }
        function selectImage(file) {
            if (!editingSlide.value)
                return;
            editingSlide.value.imageUri = file.uri;
            showImageSearchModal.value = false;
        }
        onMounted(() => {
            loadWalkthroughs();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[65] || (_cache[65] = _createElementVNode("div", { class: "page-header" }, [
                    _createElementVNode("h1", null, "Walkthrough Administration"),
                    _createElementVNode("p", { class: "subtitle" }, "Manage and configure interactive walkthroughs for user onboarding")
                ], -1)),
                _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                        (showAlert.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["alert", `alert-${alertVariant.value}`])
                            }, [
                                _createElementVNode("span", _hoisted_2, _toDisplayString(alertMessage.value), 1),
                                _createElementVNode("button", {
                                    class: "alert-close",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (showAlert.value = false))
                                }, "✕")
                            ], 2))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(AdminListSection, {
                        title: "Walkthroughs",
                        items: walkthroughs.value,
                        "selected-id": selectedWalkthrough.value?.id,
                        loading: loading.value,
                        "search-placeholder": "Search walkthroughs...",
                        "empty-message": "No walkthroughs found",
                        "search-fields": ['name', 'key'],
                        onSelect: selectWalkthrough,
                        onRefresh: refreshWalkthroughs
                    }, {
                        item: _withCtx(({ item }) => [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1),
                                _createElementVNode("div", _hoisted_6, _toDisplayString(item.key), 1)
                            ])
                        ]),
                        _: 1
                    }, 8, ["items", "selected-id", "loading"]),
                    (selectedWalkthrough.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            ref_key: "walkthroughDetailsSection",
                            ref: walkthroughDetailsSection,
                            class: "walkthrough-details-section"
                        }, [
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("h2", null, _toDisplayString(selectedWalkthrough.value.name || 'Walkthrough Details'), 1),
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("button", {
                                        class: "action-btn secondary",
                                        onClick: toggleJsonEditor
                                    }, _toDisplayString(showJsonEditor.value ? 'Form View' : 'JSON View'), 1),
                                    _createVNode(AdminHeaderActions, {
                                        loading: loading.value,
                                        "has-id": !!selectedWalkthrough.value.id,
                                        onSave: saveWalkthrough,
                                        onDelete: showDeleteConfirm,
                                        onNew: newWalkthrough
                                    }, null, 8, ["loading", "has-id"])
                                ])
                            ]),
                            (showJsonEditor.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _withDirectives(_createElementVNode("textarea", {
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((jsonEditorContent).value = $event)),
                                        class: "json-editor-textarea",
                                        spellcheck: "false"
                                    }, null, 512), [
                                        [_vModelText, jsonEditorContent.value]
                                    ]),
                                    (jsonError.value)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(jsonError.value), 1))
                                        : _createCommentVNode("", true)
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, [
                                        _cache[32] || (_cache[32] = _createElementVNode("h3", null, "Walkthrough Details", -1)),
                                        _createElementVNode("div", _hoisted_13, [
                                            _cache[27] || (_cache[27] = _createElementVNode("label", null, "Name", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((selectedWalkthrough.value.name) = $event)),
                                                class: "form-input"
                                            }, null, 512), [
                                                [_vModelText, selectedWalkthrough.value.name]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_14, [
                                            _cache[28] || (_cache[28] = _createElementVNode("label", null, "Key", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((selectedWalkthrough.value.key) = $event)),
                                                class: "form-input"
                                            }, null, 512), [
                                                [_vModelText, selectedWalkthrough.value.key]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_15, [
                                            _cache[30] || (_cache[30] = _createElementVNode("label", null, "Type", -1)),
                                            _withDirectives(_createElementVNode("select", {
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((selectedWalkthrough.value.type) = $event)),
                                                class: "form-input"
                                            }, _cache[29] || (_cache[29] = [
                                                _createElementVNode("option", { value: "0" }, "Sheet", -1),
                                                _createElementVNode("option", { value: "1" }, "Story", -1)
                                            ]), 512), [
                                                [
                                                    _vModelSelect,
                                                    selectedWalkthrough.value.type,
                                                    void 0,
                                                    { number: true }
                                                ]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_16, [
                                            _cache[31] || (_cache[31] = _createElementVNode("label", null, "Auto-scroll Seconds", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "number",
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((selectedWalkthrough.value.autoScrollSeconds) = $event)),
                                                class: "form-input"
                                            }, null, 512), [
                                                [
                                                    _vModelText,
                                                    selectedWalkthrough.value.autoScrollSeconds,
                                                    void 0,
                                                    { number: true }
                                                ]
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_17, [
                                        _createElementVNode("div", { class: "section-header" }, [
                                            _cache[33] || (_cache[33] = _createElementVNode("h3", null, "Slides", -1)),
                                            _createElementVNode("button", {
                                                class: "action-btn secondary",
                                                onClick: addSlide
                                            }, "➕ Add Slide")
                                        ]),
                                        (selectedWalkthrough.value.slides && selectedWalkthrough.value.slides.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedWalkthrough.value.slides, (slide, slideIndex) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: slide.id || slideIndex,
                                                        class: "slide-container"
                                                    }, [
                                                        _createElementVNode("div", {
                                                            class: "slide-item-header",
                                                            onClick: ($event) => (toggleSlide(slideIndex))
                                                        }, [
                                                            _createElementVNode("h4", null, [
                                                                _createElementVNode("span", {
                                                                    class: _normalizeClass(["expand-icon", { rotated: expandedSlides.value.includes(slideIndex) }])
                                                                }, "›", 2),
                                                                _createElementVNode("span", _hoisted_20, _toDisplayString(slideIndex + 1) + ".", 1),
                                                                _createTextVNode(" " + _toDisplayString(slide.title || 'Untitled Slide'), 1)
                                                            ]),
                                                            _createElementVNode("div", _hoisted_21, [
                                                                _createElementVNode("button", {
                                                                    class: "action-btn",
                                                                    onClick: _withModifiers(($event) => (moveSlideUp(slideIndex)), ["stop"]),
                                                                    disabled: slideIndex === 0,
                                                                    title: "Move slide up"
                                                                }, "⬆️", 8, _hoisted_22),
                                                                _createElementVNode("button", {
                                                                    class: "action-btn",
                                                                    onClick: _withModifiers(($event) => (moveSlideDown(slideIndex)), ["stop"]),
                                                                    disabled: slideIndex === selectedWalkthrough.value.slides.length - 1,
                                                                    title: "Move slide down"
                                                                }, "⬇️", 8, _hoisted_23),
                                                                _createElementVNode("button", {
                                                                    class: "action-btn",
                                                                    onClick: _withModifiers(($event) => (duplicateSlide(slideIndex)), ["stop"]),
                                                                    title: "Duplicate slide"
                                                                }, "📋", 8, _hoisted_24),
                                                                _createElementVNode("button", {
                                                                    class: "action-btn",
                                                                    onClick: _withModifiers(($event) => (editSlide(slide, slideIndex)), ["stop"])
                                                                }, "✏️ Edit", 8, _hoisted_25),
                                                                _createElementVNode("button", {
                                                                    class: "action-btn danger",
                                                                    onClick: _withModifiers(($event) => (deleteSlide(slideIndex)), ["stop"])
                                                                }, "🗑️ Delete", 8, _hoisted_26)
                                                            ])
                                                        ], 8, _hoisted_19),
                                                        _createVNode(_Transition, { name: "expand" }, {
                                                            default: _withCtx(() => [
                                                                (expandedSlides.value.includes(slideIndex))
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                                                        _createElementVNode("div", _hoisted_28, [
                                                                            _cache[34] || (_cache[34] = _createElementVNode("div", { class: "detail-label" }, "Image:", -1)),
                                                                            _createElementVNode("div", _hoisted_29, _toDisplayString(slide.imageUri ? '✓ Set' : '✗ Not set'), 1)
                                                                        ]),
                                                                        _createElementVNode("div", _hoisted_30, [
                                                                            _cache[35] || (_cache[35] = _createElementVNode("div", { class: "detail-label" }, "Key:", -1)),
                                                                            _createElementVNode("div", _hoisted_31, _toDisplayString(slide.key || '(empty)'), 1)
                                                                        ]),
                                                                        _createElementVNode("div", _hoisted_32, [
                                                                            _cache[36] || (_cache[36] = _createElementVNode("div", { class: "detail-label" }, "Description:", -1)),
                                                                            _createElementVNode("div", _hoisted_33, _toDisplayString(slide.description || '(empty)'), 1)
                                                                        ]),
                                                                        _createElementVNode("div", _hoisted_34, [
                                                                            _cache[37] || (_cache[37] = _createElementVNode("div", { class: "detail-label" }, "Action Text:", -1)),
                                                                            _createElementVNode("div", _hoisted_35, _toDisplayString(slide.actionText || '(empty)'), 1)
                                                                        ]),
                                                                        _createElementVNode("div", _hoisted_36, [
                                                                            _cache[38] || (_cache[38] = _createElementVNode("div", { class: "detail-label" }, "Action Button Colour:", -1)),
                                                                            _createElementVNode("div", _hoisted_37, _toDisplayString(slide.actionButtonColour || '(empty)'), 1)
                                                                        ])
                                                                    ]))
                                                                    : _createCommentVNode("", true)
                                                            ]),
                                                            _: 2
                                                        }, 1024)
                                                    ]));
                                                }), 128))
                                            ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_38, _cache[39] || (_cache[39] = [
                                                _createElementVNode("p", null, "No slides defined for this walkthrough.", -1)
                                            ])))
                                    ])
                                ]))
                        ], 512))
                        : (_openBlock(), _createElementBlock("div", _hoisted_39, _cache[40] || (_cache[40] = [
                            _createElementVNode("p", null, "Select a walkthrough to view details", -1)
                        ])))
                ]),
                _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                        (deleteConfirm.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "modal-backdrop",
                                onClick: _cache[9] || (_cache[9] = ($event) => (deleteConfirm.value = false))
                            }, [
                                _createElementVNode("div", {
                                    class: "modal-dialog",
                                    onClick: _cache[8] || (_cache[8] = _withModifiers(() => { }, ["stop"]))
                                }, [
                                    _createElementVNode("div", _hoisted_40, [
                                        _cache[41] || (_cache[41] = _createElementVNode("h3", null, "Confirm Delete", -1)),
                                        _createElementVNode("button", {
                                            class: "modal-close",
                                            onClick: _cache[6] || (_cache[6] = ($event) => (deleteConfirm.value = false))
                                        }, "✕")
                                    ]),
                                    _createElementVNode("div", _hoisted_41, [
                                        _createElementVNode("p", null, [
                                            _cache[42] || (_cache[42] = _createTextVNode("Are you sure you want to delete ")),
                                            _createElementVNode("strong", null, _toDisplayString(selectedWalkthrough.value.title), 1),
                                            _cache[43] || (_cache[43] = _createTextVNode("?"))
                                        ]),
                                        _cache[44] || (_cache[44] = _createElementVNode("p", null, "This action cannot be undone.", -1))
                                    ]),
                                    _createElementVNode("div", _hoisted_42, [
                                        _createElementVNode("button", {
                                            class: "action-btn secondary",
                                            onClick: _cache[7] || (_cache[7] = ($event) => (deleteConfirm.value = false))
                                        }, "Cancel"),
                                        _createElementVNode("button", {
                                            class: "action-btn danger",
                                            onClick: deleteWalkthrough
                                        }, "Delete")
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                        (showSlideModal.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "modal-backdrop",
                                onClick: closeSlideModal
                            }, [
                                _createElementVNode("div", {
                                    class: "modal-dialog",
                                    onClick: _cache[22] || (_cache[22] = _withModifiers(() => { }, ["stop"]))
                                }, [
                                    _createElementVNode("div", _hoisted_43, [
                                        _createElementVNode("h3", null, _toDisplayString(editingSlideIndex.value === null ? 'Add' : 'Edit') + " Slide", 1),
                                        _createElementVNode("button", {
                                            class: "modal-close",
                                            onClick: closeSlideModal
                                        }, "✕")
                                    ]),
                                    _createElementVNode("div", _hoisted_44, [
                                        _createElementVNode("div", _hoisted_45, [
                                            _cache[45] || (_cache[45] = _createElementVNode("label", null, "Title", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((editingSlide.value.title) = $event)),
                                                class: "form-input"
                                            }, null, 512), [
                                                [_vModelText, editingSlide.value.title]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_46, [
                                            _cache[46] || (_cache[46] = _createElementVNode("label", null, "Description", -1)),
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((editingSlide.value.description) = $event)),
                                                class: "form-textarea",
                                                rows: "2"
                                            }, null, 512), [
                                                [_vModelText, editingSlide.value.description]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_47, [
                                            _cache[47] || (_cache[47] = _createElementVNode("label", null, "Sub-description", -1)),
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((editingSlide.value.subDescription) = $event)),
                                                class: "form-textarea",
                                                rows: "2"
                                            }, null, 512), [
                                                [_vModelText, editingSlide.value.subDescription]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_48, [
                                            _cache[48] || (_cache[48] = _createElementVNode("label", null, "Screen Title", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((editingSlide.value.screenTitle) = $event)),
                                                class: "form-input"
                                            }, null, 512), [
                                                [_vModelText, editingSlide.value.screenTitle]
                                            ])
                                        ]),
                                        _cache[57] || (_cache[57] = _createElementVNode("hr", { class: "modal-divider" }, null, -1)),
                                        _createElementVNode("div", _hoisted_49, [
                                            _cache[49] || (_cache[49] = _createElementVNode("label", null, "Action Text", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((editingSlide.value.actionText) = $event)),
                                                class: "form-input"
                                            }, null, 512), [
                                                [_vModelText, editingSlide.value.actionText]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_50, [
                                            _cache[50] || (_cache[50] = _createElementVNode("label", null, "Action URI", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((editingSlide.value.actionUri) = $event)),
                                                class: "form-input"
                                            }, null, 512), [
                                                [_vModelText, editingSlide.value.actionUri]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_51, [
                                            _cache[51] || (_cache[51] = _createElementVNode("label", null, "Action Button Colour", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((editingSlide.value.actionButtonColour) = $event)),
                                                class: "form-input",
                                                placeholder: "e.g. #25D366"
                                            }, null, 512), [
                                                [_vModelText, editingSlide.value.actionButtonColour]
                                            ])
                                        ]),
                                        _cache[58] || (_cache[58] = _createElementVNode("hr", { class: "modal-divider" }, null, -1)),
                                        _createElementVNode("div", _hoisted_52, [
                                            _cache[52] || (_cache[52] = _createElementVNode("label", null, "Small Text", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((editingSlide.value.smallText) = $event)),
                                                class: "form-input"
                                            }, null, 512), [
                                                [_vModelText, editingSlide.value.smallText]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_53, [
                                            _cache[53] || (_cache[53] = _createElementVNode("label", null, "Small Link", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((editingSlide.value.smallLink) = $event)),
                                                class: "form-input"
                                            }, null, 512), [
                                                [_vModelText, editingSlide.value.smallLink]
                                            ])
                                        ]),
                                        _cache[59] || (_cache[59] = _createElementVNode("hr", { class: "modal-divider" }, null, -1)),
                                        _createElementVNode("div", _hoisted_54, [
                                            _cache[54] || (_cache[54] = _createElementVNode("label", null, "Key", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((editingSlide.value.key) = $event)),
                                                class: "form-input"
                                            }, null, 512), [
                                                [_vModelText, editingSlide.value.key]
                                            ])
                                        ]),
                                        _cache[60] || (_cache[60] = _createElementVNode("hr", { class: "modal-divider" }, null, -1)),
                                        _createElementVNode("div", _hoisted_55, [
                                            _cache[55] || (_cache[55] = _createElementVNode("label", null, "Image URI", -1)),
                                            _createElementVNode("div", _hoisted_56, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((editingSlide.value.imageUri) = $event)),
                                                    class: "form-input"
                                                }, null, 512), [
                                                    [_vModelText, editingSlide.value.imageUri]
                                                ]),
                                                _createElementVNode("button", {
                                                    class: "action-btn",
                                                    type: "button",
                                                    onClick: openImageSearch
                                                }, "🖼️")
                                            ]),
                                            (editingSlide.value.imageUri)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                                    (editingSlide.value.imageUri.endsWith('.mp4'))
                                                        ? (_openBlock(), _createElementBlock("video", {
                                                            key: 0,
                                                            src: editingSlide.value.imageUri,
                                                            class: "image-preview",
                                                            muted: "",
                                                            preload: "metadata"
                                                        }, null, 8, _hoisted_58))
                                                        : (_openBlock(), _createElementBlock("img", {
                                                            key: 1,
                                                            src: editingSlide.value.imageUri,
                                                            alt: "Slide Image Preview",
                                                            class: "image-preview"
                                                        }, null, 8, _hoisted_59))
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _cache[61] || (_cache[61] = _createElementVNode("hr", { class: "modal-divider" }, null, -1)),
                                        _createElementVNode("div", _hoisted_60, [
                                            _createElementVNode("label", null, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "checkbox",
                                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((editingSlide.value.videoLoop) = $event)),
                                                    class: "form-checkbox"
                                                }, null, 512), [
                                                    [_vModelCheckbox, editingSlide.value.videoLoop]
                                                ]),
                                                _cache[56] || (_cache[56] = _createTextVNode(" Video Loop "))
                                            ])
                                        ]),
                                        _cache[62] || (_cache[62] = _createElementVNode("hr", { class: "modal-divider" }, null, -1))
                                    ]),
                                    _createElementVNode("div", { class: "modal-footer" }, [
                                        _createElementVNode("button", {
                                            class: "action-btn secondary",
                                            onClick: closeSlideModal
                                        }, "Cancel"),
                                        _createElementVNode("button", {
                                            class: "action-btn primary",
                                            onClick: saveSlide
                                        }, "Save")
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                        (showImageSearchModal.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "modal-backdrop",
                                onClick: _cache[26] || (_cache[26] = ($event) => (showImageSearchModal.value = false))
                            }, [
                                _createElementVNode("div", {
                                    class: "modal-dialog modal-large",
                                    onClick: _cache[25] || (_cache[25] = _withModifiers(() => { }, ["stop"]))
                                }, [
                                    _createElementVNode("div", _hoisted_61, [
                                        _cache[63] || (_cache[63] = _createElementVNode("h3", null, "Select an Image", -1)),
                                        _createElementVNode("button", {
                                            class: "modal-close",
                                            onClick: _cache[23] || (_cache[23] = ($event) => (showImageSearchModal.value = false))
                                        }, "✕")
                                    ]),
                                    _createElementVNode("div", _hoisted_62, [
                                        _createElementVNode("div", _hoisted_63, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((imageSearchQuery).value = $event)),
                                                type: "text",
                                                placeholder: "Search images...",
                                                class: "search-input"
                                            }, null, 512), [
                                                [_vModelText, imageSearchQuery.value]
                                            ])
                                        ]),
                                        (cdnFiles.value.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCdnFiles.value, (file) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: file.fileName,
                                                        class: "file-card",
                                                        onClick: ($event) => (selectImage(file))
                                                    }, [
                                                        _createElementVNode("div", _hoisted_66, [
                                                            _createElementVNode("img", {
                                                                src: file.uri,
                                                                alt: file.fileName
                                                            }, null, 8, _hoisted_67)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_68, [
                                                            _createElementVNode("div", {
                                                                class: "file-card-name",
                                                                title: file.fileName
                                                            }, _toDisplayString(file.fileName), 9, _hoisted_69)
                                                        ])
                                                    ], 8, _hoisted_65));
                                                }), 128))
                                            ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_70, _cache[64] || (_cache[64] = [
                                                _createElementVNode("p", null, "No images found in CDN.", -1)
                                            ])))
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
